import React from 'react';
import style from './style.module.scss';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {Typography} from 'components/Typography';
import NextLink from 'next/link';

type TPropertiesProps = IProductSnippet['properties'];

export const Properties = (props: TPropertiesProps) => {
    const {list, onPropertyClick} = props;

    return (
        <>
            {list.map((item) => (
                <NextLink
                    className={style.item}
                    key={item.code}
                    href={item.filterUrl || ''}
                    onClick={() => onPropertyClick(item.code)}
                >
                    <Typography
                        variants={{
                            DT: 'label-14-r',
                            TB: 'label-14-r',
                            MB: 'label-12-r',
                        }}
                    >
                        {`${item.formattedValue.content}${item.formattedValue.suffix}`}
                    </Typography>
                </NextLink>
            ))}
        </>
    );
};
